import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest, patchRequest, postRequest} from "../../../api";
import {getUserData} from "../../splash/helpers";

export const handleGetAccountValues = createAsyncThunk('wallet/handleGetAccountValues', async(params) => {
    try{
        const {data} = await getRequest(`/coach/financial-document/statistics`, params)
        return data
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleLoadInputs = createAsyncThunk('wallet/handleLoadInputs', async(allData) => {
    const {params, inputPage} = allData
    try{
        const {data} = await getRequest(`/coach/financial-document/${inputPage}`, { doc_type: 'addition', ...params })
        return {data, params, inputPage}
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleLoadOutputs = createAsyncThunk('wallet/handleLoadOutputs', async(allData) => {
    const {params, outputPage} = allData
    try{
        const {data} = await getRequest(`/coach/financial-document/${outputPage}`, { doc_type: 'deduction', ...params })
        return {data, params, outputPage}
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleUpdateAccountInfo = createAsyncThunk('wallet/handleUpdateAccountInfo', async(allData) => {
    const {coachId, data, dispatch} = allData
    try{
        const response = await patchRequest(`/coach/${coachId}`, data)
        console.log('dispatch',dispatch)
        await getUserData(dispatch)
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleDepositRequest = createAsyncThunk('wallet/handleDepositRequest', async(dispatch) => {
    try{
        const response = await postRequest('/coach/deposit')
        return dispatch
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

const walletSlice = createSlice({
    name: 'wallet',
    initialState: {
        accountValues: {
            total_deposit: 20000,
            total_withdrawal: 0
        },
        inputs: [],
        outputs: [],
        walletLoading: false,
        accountInfoLoading: false,
        depositLoading: false,
        editCardNom: false,
    },
    reducers: {
        setEditCardNom: (state, action) => {
            state.editCardNom = action?.payload
        },
        setAccountInfoLoading: (state, action) => {
            state.accountInfoLoading = action?.payload
        },
        setDepositLoading: (state, action) => {
            state.depositLoading = action?.payload
        },
    },
    extraReducers(builder){
        builder
            .addCase(handleGetAccountValues.fulfilled, (state, action) => {
                state.accountValues = {
                    total_withdrawal: action?.payload?.total_withdrawal,
                    total_deposit: action?.payload?.total_deposit,
                }
            });
        builder
            .addCase(handleLoadInputs.fulfilled, (state, action) => {
                const payload = action?.payload
                if(payload?.params.start_date && payload?.params.end_date && payload?.inputPage === 1){
                    state.inputs = [].concat(payload?.data)
                }
                else{
                    state.inputs = state.inputs.concat(payload?.data)
                }
                state.walletLoading = false
            })
            .addCase(handleLoadInputs.pending, (state, action) => {
                state.walletLoading = true
            })
            .addCase(handleLoadInputs.rejected, (state, action) => {
                state.walletLoading = false
            });
        builder
            .addCase(handleLoadOutputs.fulfilled, (state, action) => {
                const payload = action?.payload
                if(payload?.params.start_date && payload?.params.end_date && payload?.outputPage === 1){
                    state.outputs = [].concat(payload?.data)
                }
                else{
                    state.outputs = state.outputs.concat(payload?.data)
                }
                state.walletLoading = false
            })
            .addCase(handleLoadOutputs.pending, (state, action) => {
                state.walletLoading = true
            })
            .addCase(handleLoadOutputs.rejected, (state, action) => {
                state.walletLoading = false
            });
        builder
            .addCase(handleUpdateAccountInfo.fulfilled,  (state, action) => {
                console.log('end')
                state.accountInfoLoading = 'sentData'
                state.editCardNom = false
            })
            .addCase(handleUpdateAccountInfo.pending, (state, action) => {
                console.log('pending')

                state.accountInfoLoading = true
            })
            .addCase(handleUpdateAccountInfo.rejected, (state, action) => {
                state.accountInfoLoading = 'error'
            })
        builder
            .addCase(handleDepositRequest.fulfilled, async (state, action) => {
                state.depositLoading = 'sentData'
                await getUserData(action?.payload)
            })
            .addCase(handleDepositRequest.pending, (state, action) => {
                state.depositLoading = true
            })
            .addCase(handleDepositRequest.rejected, (state, action) => {
                state.depositLoading = 'error'
            })
    }
})

export const {setEditCardNom, setAccountInfoLoading, setDepositLoading} = walletSlice.actions
export const selectAccountValues = state => state.wallet.accountValues
export const selectWalletLoading = state => state.wallet.walletLoading
export const selectAccountInfoLoading = state => state.wallet.accountInfoLoading
export const selectDepositLoading = state => state.wallet.depositLoading
export const selectEditCardNom = state => state.wallet.editCardNom
export const selectInputsArray = state => state.wallet.inputs
export const selectOutputsArray = state => state.wallet.outputs
export default walletSlice.reducer